export default function DynamicColorNote({fill}) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_7536_7403)">
        <path
          d="M13.3604 13.3604L14.0372 19.4698L19.4698 14.0372L13.3604 13.3604Z"
          fill="#FFAE46"
        />
        <path
          d="M18.7928 0L16.9819 14.5674H18.1892C19.1893 14.5674 20 13.7567 20 12.7565V0.301811C20 0.221766 19.9682 0.144999 19.9116 0.0883984C19.855 0.0317978 19.7783 0 19.6982 0L18.7928 0Z"
          fill={fill}
        />
        <path
          d="M18.7928 12.7565V0H0.301811C0.221766 0 0.144999 0.0317978 0.0883984 0.0883984C0.0317978 0.144999 0 0.221766 0 0.301811L0 19.6982C0 19.7782 0.0317978 19.855 0.0883984 19.9116C0.144999 19.9682 0.221766 20 0.301811 20H12.7565C13.7567 20 14.5674 19.1893 14.5674 18.1891V14.5674H16.9819C17.982 14.5674 18.7928 13.7567 18.7928 12.7565Z"
          fill={fill}
        />
        <rect x="3" y="5" width="13" height="2" rx="1" fill="#7A7E59" />
        <rect x="3" y="9" width="10" height="2" rx="1" fill="#7A7E59" />
        <rect x="3" y="13" width="6" height="2" rx="1" fill="#7A7E59" />
      </g>
      <defs>
        <clipPath id="clip0_7536_7403">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
